import { MarketplaceFilter } from "../components/Marketplace/MarketplaceFilter/MarketplaceFilter";
import { MarketplaceNavbar } from "../components/Marketplace/MarketplaceNavbar/MarketplaceNavbar";
import { ProductsGrid } from "../components/ProductsGrid/ProductsGrid";
import { NftDefaultValue } from "../defalult/NftDefaultValue";
import { CollectionDefaultValue } from "../defalult/CollectionDefaultValue";
import { CreatorDefaultValue } from "../defalult/CreatorDefaultValue";
import { useEffect, useState } from "react";

const Nfts = NftDefaultValue;
const Collections = CollectionDefaultValue;
const Creators = CreatorDefaultValue;

const tabList = ["NFTs", "Collections", "Creators"];

const activeComponent = {
  NFTs: <ProductsGrid products={Nfts} />,
  Collections: <ProductsGrid products={Collections} collection={true} />,
  Creators: <ProductsGrid products={Creators} creators={true} />,
};

export const Marketplace = ({ active }) => {
  const [activeTab, setActiveTab] = useState("NFTs");

  useEffect(() => {
    setActiveTab(active);
  }, [active]);

  return (
    <>
      <MarketplaceNavbar setActiveTab={setActiveTab} tabList={tabList} activeTab={activeTab} />
      <MarketplaceFilter activeTab={activeTab} />
      {activeComponent[activeTab]}
    </>
  );
};
